import React from 'react';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import ReportErrors from '@atlassian/jira-errors-handling/src/utils/reporting-error-boundary.tsx';
import { TransitionsQuery as OriginalTransitionsQuery } from './main.tsx';
import type { Props } from './types.tsx';

const WrappedTransitionsQuery = (props: Props): React.JSX.Element => (
	<ErrorBoundary id="issue.fields.status.transitions-query">
		<ReportErrors
			id="fields.status.transitions-query"
			packageName="jiraIssueFieldStatus"
			sendToPrivacyUnsafeSplunk
		>
			<OriginalTransitionsQuery {...props} />
		</ReportErrors>
	</ErrorBoundary>
);

export { WrappedTransitionsQuery as TransitionsQuery };
